const parallaxArticle = 30;

const parallaxDuration = 800;
const parallaxCollectionTitleMov = -50;
const parallaxSloganMov = -75;
const parallaxDiscoverTextMov = -100;
const parallaxTechListTitleMov = -125;
const parallaxTechListLinksMov = -150;
const parallaxShopBtnMov = -175;
const inactiveSlideOpacity = 0;

const parallaxDurationMobile = 800;
const parallaxCollectionTitleMovMobile = -40;
const parallaxSloganMovMobile = -50;
const parallaxDiscoverTextMovMobile = -60;
const parallaxTechListTitleMovMobile = -70;
const parallaxTechListLinksMovMobile = -80;
const parallaxShopBtnMovMobile = -90;
const inactiveSlideOpacityMobile = 0;

const mobileWidthBreakpoint = 768;

const collectionSlideshowSwiperPrevBtnClass = "collections-slideshow-prev-btn";
const collectionSlideshowSwiperNextBtnClass = "collections-slideshow-next-btn";
const collectionSlideshowSwiperPaginationClass = "collections-slideshow-pagination";

const slideCollectionTitleDivs = Array.from(document.querySelectorAll(".section-collections-slideshow .collection-title"));
const slideSloganDivs = Array.from(document.querySelectorAll(".section-collections-slideshow .collection-slogan"));
const slideDiscoverTextDivs = Array.from(document.querySelectorAll(".section-collections-slideshow .collection-discover-text"));
const slideTechListTitleDivs = Array.from(document.querySelectorAll(".section-collections-slideshow .tech-list-title"));
const slideTechListLinksDivs = Array.from(document.querySelectorAll(".section-collections-slideshow .tech-list"));
const slideShopBtnDivs = Array.from(document.querySelectorAll(".section-collections-slideshow .shop-collection-btn"));
const slideExempleArticlesDivs = Array.from(document.querySelectorAll(".section-collections-slideshow .collections-slideshow-exemple-articles-wrapper"));

const collectionsSlideshowSpeed = 600;
console.log("Swiper slide count:", document.querySelectorAll(".swiper-slide").length);

const collectionsSlideshowSwiper = new Swiper(".collections-slideshow-swiper-wrapper", {
  // Optional parameters
  resistanceRatio:0,
  parallax: true,
  direction: "horizontal",
  shortSwipes: true,
  simulateTouch: true,
  slideToClickedSlide: false,
  loop: true,
  speed: collectionsSlideshowSpeed,
  autoHeight: true,
  effect: "slide",
  allowSlidePrev: true,
  allowSlideNext: true,
  allowTouchMove: true,
  slidesPerView: 1,
  // Navigation arrows
  navigation: {
    prevEl: "." + collectionSlideshowSwiperPrevBtnClass,
    nextEl: "." + collectionSlideshowSwiperNextBtnClass,
  },
  pagination: {
    el: "." + collectionSlideshowSwiperPaginationClass,
    clickable: true,
    renderBullet: function (idx, className) {
      return `<div class="${className}"></div>`;
    },
  },
  on: {
    init: () => {
      for (let i = 0; i < slideExempleArticlesDivs.length;i++){
        const div = slideExempleArticlesDivs[i];
        if (i == 0) {
          div.style.opacity = 1;
          div.style.transform = `translateY(0px)`;
        }
        else {
          div.style.opacity = 0;
          div.style.transform = `translateY(${parallaxArticle}px)`;
        }
      }
    },
    slideChange: (swiper) => {
      //swiper.pagination.render();
      //swiper.pagination.update();
    },
    slidePrevTransitionStart: (swiper) => {
      for (let i = 0; i < slideExempleArticlesDivs.length;i++){
        const div = slideExempleArticlesDivs[i];
        if (i == swiper.realIndex){
          setTimeout(() => {
            if (div.style.opacity != 1) div.style.opacity = 1;
            if (div.style.transform != `translateY(0px)`) div.style.transform = `translateY(0px)`;
          }, collectionsSlideshowSpeed/2);
        }
        else {
          if (div.style.opacity != 0) div.style.opacity = 0;
          if (div.style.transform != `translateY(${parallaxArticle}px)`) div.style.transform = `translateY(${parallaxArticle}px)`;
        }
      }
    },
    slideNextTransitionStart: (swiper) => { 
      for (let i = 0; i < slideExempleArticlesDivs.length;i++){
        const div = slideExempleArticlesDivs[i];
        if (i == swiper.realIndex){
          setTimeout(() => {
            if (div.style.opacity != 1) div.style.opacity = 1;
            if (div.style.transform != `translateY(0px)`) div.style.transform = `translateY(0px)`;
          }, collectionsSlideshowSpeed/2);
        }
        else {
          if (div.style.opacity != 0) div.style.opacity = 0;
          if (div.style.transform != `translateY(${parallaxArticle}px)`) div.style.transform = `translateY(${parallaxArticle}px)`;
        }
      }
    },
    setTransition: (swiper, transition) => {
      //Current article div
      activeArticlesDiv = slideExempleArticlesDivs[swiper.realIndex];
      activeArticlesDiv.style.transitionDuration = (transition/1000) / 2 + "s";
      //Previous article div (wrap to the last one if active slide is the first one)
      prevArticlesDiv = slideExempleArticlesDivs[swiper.realIndex != 0 ? swiper.realIndex-1 : slideExempleArticlesDivs.length-1];
      prevArticlesDiv.style.transitionDuration = (transition/1000) / 2 + "s";
      //Next article div (wrap to the first one if active slide is the last one)
      nextArticlesDiv = slideExempleArticlesDivs[swiper.realIndex != slideExempleArticlesDivs.length-1 ? swiper.realIndex+1 : 0];
      nextArticlesDiv.style.transitionDuration = (transition/1000) / 2 + "s";
    },
    setTranslate: (swiper, translation) => {
      const completionPercent = (translation*-1)%swiper.width / swiper.width;
      const activeSlide = swiper.slides[swiper.activeIndex];

      //If the progress is below 50% then the active slide hasn't changed so the active needs to be faded out and everything else is hidden
      if (completionPercent < 0.5){
        //Current article div
        activeArticlesDiv = slideExempleArticlesDivs[swiper.realIndex];
        activeArticlesDiv.style.opacity = 1 - (completionPercent * 2);
        activeArticlesDiv.style.transform = `translateY(${parallaxArticle - (parallaxArticle*(1 - (completionPercent * 2)))}px)`;
        //Previous article div (wrap to the last one if active slide is the first one)
        prevArticlesDiv = slideExempleArticlesDivs[swiper.realIndex != 0 ? swiper.realIndex-1 : slideExempleArticlesDivs.length-1];
        prevArticlesDiv.style.opacity = 0;
        //Next article div (wrap to the first one if active slide is the last one)
        nextArticlesDiv = slideExempleArticlesDivs[swiper.realIndex != slideExempleArticlesDivs.length-1 ? swiper.realIndex+1 : 0];
        nextArticlesDiv.style.opacity = 0;
      }
      //If the progress is above 50% then the active slide has changed so the active needs to be faded in and everything else hidden
      else {
        //Current article div
        activeArticlesDiv = slideExempleArticlesDivs[swiper.realIndex];
        activeArticlesDiv.style.opacity = (2*completionPercent)-1;
        activeArticlesDiv.style.transform = `translateY(${parallaxArticle - (parallaxArticle*((2*completionPercent)-1))}px)`;
        //Previous article div (wrap to the last one if active slide is the first one)
        prevArticlesDiv = slideExempleArticlesDivs[swiper.realIndex != 0 ? swiper.realIndex-1 : slideExempleArticlesDivs.length-1];
        prevArticlesDiv.style.opacity = 0;
        //Next article div (wrap to the first one if active slide is the last one)
        nextArticlesDiv = slideExempleArticlesDivs[swiper.realIndex != slideExempleArticlesDivs.length-1 ? swiper.realIndex+1 : 0];
        nextArticlesDiv.style.opacity = 0;
      }
    }
  },
});


window.addEventListener("resize", windowResizedCollectionSlideshow);

let lastResize = null;
//Run it once on load
windowResizedCollectionSlideshow();

function windowResizedCollectionSlideshow(){
  const currentWidth = window.innerWidth;
    
  //If this resize just broke through into the mobile breakpoint (not triggered if it was already in mobile)
  if (currentWidth <= mobileWidthBreakpoint && (!lastResize || lastResize > mobileWidthBreakpoint)){
        slideCollectionTitleDivs.forEach(div => {
      div.dataset.swiperParallaxY = parallaxCollectionTitleMovMobile;
      div.dataset.swiperParallaxDuration = parallaxDurationMobile;
      div.dataset.swiperParallaxOpacity = inactiveSlideOpacityMobile;
    });
    slideSloganDivs.forEach(div => {
      div.dataset.swiperParallaxY = parallaxSloganMovMobile;
      div.dataset.swiperParallaxDuration = parallaxDurationMobile;
      div.dataset.swiperParallaxOpacity = inactiveSlideOpacityMobile;
    });
    slideDiscoverTextDivs.forEach(div => {
      div.dataset.swiperParallaxY = parallaxDiscoverTextMovMobile;
      div.dataset.swiperParallaxDuration = parallaxDurationMobile;
      div.dataset.swiperParallaxOpacity = inactiveSlideOpacityMobile;
    });
    slideTechListTitleDivs.forEach(div => {
      div.dataset.swiperParallaxY = parallaxTechListTitleMovMobile;
      div.dataset.swiperParallaxDuration = parallaxDurationMobile;
      div.dataset.swiperParallaxOpacity = inactiveSlideOpacityMobile;
    });
    slideTechListLinksDivs.forEach(div => {
      div.dataset.swiperParallaxY = parallaxTechListLinksMovMobile;
      div.dataset.swiperParallaxDuration = parallaxDurationMobile;
      div.dataset.swiperParallaxOpacity = inactiveSlideOpacityMobile;
    });
    slideShopBtnDivs.forEach(div => {
      div.dataset.swiperParallaxY = parallaxShopBtnMovMobile;
      div.dataset.swiperParallaxDuration = parallaxDurationMobile;
      div.dataset.swiperParallaxOpacity = inactiveSlideOpacityMobile;
    });
  }
  //If this resize just broke through into the desktop breakpoint (not triggered if it was already in desktop)
  else if (currentWidth > mobileWidthBreakpoint && (!lastResize || lastResize <= mobileWidthBreakpoint)){
    slideCollectionTitleDivs.forEach(div => {
      div.dataset.swiperParallaxY = parallaxCollectionTitleMov;
      div.dataset.swiperParallaxDuration = parallaxDuration;
      div.dataset.swiperParallaxOpacity = inactiveSlideOpacity;
    });
    slideSloganDivs.forEach(div => {
      div.dataset.swiperParallaxY = parallaxSloganMov;
      div.dataset.swiperParallaxDuration = parallaxDuration;
      div.dataset.swiperParallaxOpacity = inactiveSlideOpacity;
    });
    slideDiscoverTextDivs.forEach(div => {
      div.dataset.swiperParallaxY = parallaxDiscoverTextMov;
      div.dataset.swiperParallaxDuration = parallaxDuration;
      div.dataset.swiperParallaxOpacity = inactiveSlideOpacity;
    });
    slideTechListTitleDivs.forEach(div => {
      div.dataset.swiperParallaxY = parallaxTechListTitleMov;
      div.dataset.swiperParallaxDuration = parallaxDuration;
      div.dataset.swiperParallaxOpacity = inactiveSlideOpacity;
    });
    slideTechListLinksDivs.forEach(div => {
      div.dataset.swiperParallaxY = parallaxTechListLinksMov;
      div.dataset.swiperParallaxDuration = parallaxDuration;
      div.dataset.swiperParallaxOpacity = inactiveSlideOpacity;
    });
    slideShopBtnDivs.forEach(div => {
      div.dataset.swiperParallaxY = parallaxShopBtnMov;
      div.dataset.swiperParallaxDuration = parallaxDuration;
      div.dataset.swiperParallaxOpacity = inactiveSlideOpacity;
    });
  }

  lastResize = currentWidth;
}
